<app-nav></app-nav>
<section class="covidProtection" id="section1" *ngIf="!quotesDetailsTable">
  <div class="container">
    <app-click-to-call></app-click-to-call>
    <div class="col">
      <form name="form" #f="ngForm">
        <center>
          <img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/covid-19/covid-19-banner.png"
            class="img-responsive main-image">
        </center>
        <center class="sub-title">
          <!-- <p>Get Quotes in just 1 click</p> -->
        </center>
        <div class="col sum-container">
          <div class="text-center top-gap-sm">
            <h3>Thank You</h3>
            <h6>We will call you back within 24 hours.</h6>
            <!-- <button class="btn btn-bordered-blue" (click)="showQuote()">Next</button> -->
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- <div class="footer-bar">
    <span><b><u>Fill Info</u></b></span><span class="next-step-icon"></span><span>Quote Page</span><span
      class="next-step-icon"></span><span>Contact Info.</span><span class="next-step-icon"></span><span>Proposal
      Form</span><span class="next-step-icon"></span><span>Pay</span>
  </div> -->
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<section class="covid-quote-details" id="section2" *ngIf="quotesDetailsTable">
  <span class="back-icon" (click)="backtoFirstScreen()"><img class="img-responsive"
      src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/back.svg"></span>
  <table class="quote-details-table">
    <tbody>
      <tr class="first no-border">
        <td class="">
          <div></div>
        </td>
        <td class="">
          <div></div>
        </td>
      </tr>
      <tr class="no-border">
        <td rowspan="3">
          <span><b>Total Premium</b><br><span class="sub-title">(INR, Excluding Taxes)</span></span>
        </td>
        <td>
          <div>
            <div class="insurer-image">
              <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/logo-covid-reliance.png"
                class="img-responsive" width="100%" alt="Covid Protection">
            </div>
          </div>
        </td>
      </tr>
      <tr class="no-border">
        <td>
          <div>
            <div class="premium-amount">
              <label class="amount-title"><span class="amount">₹ 2040</span><br><span class="sub-title">Per
                  annum</span></label>
            </div>
          </div>
        </td>
      </tr>
      <tr class="no-border">
        <td class="">
          <div>
            <div class="btn_row">
              <div class="col">
                <span><a href="javascript:void(0)" class="downloadPDF" (click)="downloadPDF();"></a></span>
                <span><button type="button" class="btn btn-bordered-blue btn-buy"
                  (click)="openModal(templateThankYou);sendPDF()">Email</button></span>
                <span><button type="button" class="btn btn-bordered-blue btn-buy"
                  routerLink="/covid-protection-proposal">Buy</button></span>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr class="first no-border">
        <td class="">
          <div></div>
        </td>
        <td class="">
          <div></div>
        </td>
      </tr>
      <tr class="no-border">
        <td colspan="2" class="blue-strip">
          <div class="blue-strip-content">
            <div>Covers Opted For</div>
          </div>
        </td>
        <td style="display:none;" class=""></td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Sum Insured</span>
          </div>
        </td>
        <td>
          <div>
            <span>2,00,000/-</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Plan Name</span>
          </div>
        </td>
        <td>
          <div>
            <span>Silver</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Eligibility Criteria-Age</span>
          </div>
        </td>
        <td>
          <div>
            <span>18yrs-60yrs</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Base Cover</span>
          </div>
        </td>
        <td>
          <div>
            <span>Diagnosis</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Type of Policy</span>
          </div>
        </td>
        <td>
          <div>
            <span>Individual</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <span>Policy Tenure</span>
          </div>
        </td>
        <td>
          <div>
            <span>1 Year</span>
          </div>
        </td>
      </tr>
      <tr class="no-border">
        <td colspan="2">
          <div class="last-border">
            <span>Note : These are indicative prices. Insurance is the subject matter of solicitation.</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <ng-template #templateThankYou>
    <!-- <div class="modal-header">
        
      </div> -->
    <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
      <div class="modal-body" id="contactInfoModal">
        <div class="col">
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col text-center mt-4">
          <h4 class="modal-title">Thank You</h4>
          <p>Quote has been mailed to your registered mail.</p>
        </div>
      </div>
    </form>

  </ng-template>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
